import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-angle-grinder-icon',
  templateUrl: './tools-angle-grinder.component.html'
})
export class ToolsAngleGrinderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
